import React, { useEffect, useState } from 'react'
import './OrbitAndReview.scss'
import useDimensions from '../../../hooks/useDimensions'
import PopContent from './shared/PopContent'
import Media from '../../partials/Media'
import Button from '../../partials/Button/Button';
import BackButton from '../../partials/Button/BackButton'
import Patterns from '../../partials/UI/SVG/Patterns'
import ProgressBubbles from '../../partials/ProgressBubbles/ProgressBubbles'

import SVGRoadMap from './SVGRoadMap/';
import InteractionContainer from '../../partials/InteractionContainer/InteractionContainer';

import WrongIcon from './assets/img/quesions/wrong.svg';
import CorrectIcon from './assets/img/quesions/correct.svg';

const OrbitAndReview = (props) => {

    const {data} = props;
    console.log(data);

    const [idx, setIdx] = useState(0);
    const [question, setQuestion ] = useState()

    const [selectedOption, setSelectedOption] = useState(false)

    const [showFeedback, setShowFeedback] = useState(false)
    const [interactionState, setInteractionState] = useState({ view: 'orbit' })
    const [viewPortRef, viewPort] = useDimensions(true)
    const [choiceFeedbackRef] = useDimensions(true)
    const [decisionContentRef] = useDimensions(true)

    const [showDecisionContent, setShowDecisionContent] = useState(false)
    const [decisionContentState, setDecisionContentState] = useState()
    const [clickable, setClickable] = useState(true)
    const [optionClicked, setOptionClicked] = useState([])


    useEffect(() => {

        setQuestion(data.questions[idx]);

    }, [])
    useEffect(()=>{
        if(question) {
            let arr = []
            question.answers.map(a=>{arr.push(null)})
            setOptionClicked(arr)
    }
    },[question])

    useEffect(()=>{
        console.log(optionClicked)
    },[optionClicked])

    /**
     * Calculate Position of Elements
     * @param {*} e
     * @returns
     */
     const calcPos = (e, params ) =>{

        const {meridian, propX, propY} = params

        const point = e.currentTarget.getBoundingClientRect();

        const offsetX = point.left - (viewPort.x);
        const offsetY = point.top - (viewPort.y);
        const x = (offsetX > meridian ? ( offsetX - 310): ( offsetX + point.width)) - propX;
        const y = offsetY + propY;

        return  { x, y }
      }


    /**
     * setFeedbackState
     * Show and Data Handler
     * @param {*} answer
     * @param {*} show
     */
    const setFeedbackState = (answer, show) => {

        setSelectedOption(answer)
        setShowFeedback(show)

    }
    /**
     * setDecisionState
     * Show and Data Handler
     * @param {*} decision
     * @param {*} show
     */
    const setDecisionState = (decision, show) => {

        setDecisionContentState(decision)
        setShowDecisionContent(show)

    }
    /**
     * selectAnswer
     * When user select a answer, this
     * marks the item as selected and
     * returns an array of obj
     * @param {*} array
     * @param {*} obj
     * @returns
     */
    const selectAnswer = (array, obj) => {

        return array.map((answer)=>{

            let select

            if(answer.text===obj.text) {
                select = (answer.selected ? false : true)
            }
            return { ...answer, selected: select };
        })

    }

    /**
     *
     * @param {*} e
     * @param {*} option
     * @param {*} i
     */
    const onSelectOptionHandle = (e, option,i) => {
        const show = true;

        const pos = {x:150,y:300};
        setFeedbackState({ ...option, pos, show }, show)
        setClickable(false)

        let temp = optionClicked
        temp[i] = option.correct
        console.log(temp)
        setOptionClicked(temp)

    }

    const onNextHandle = () => {

        setFeedbackState(false, false)
        setClickable(true)
        const nextIdx = idx+1;

        if(nextIdx > data.questions.length -1){
            // setInteractionState({
            //     view: 'decisionsRoadmap',
            // })
            props.onComplete()
        }
        else{
            setQuestion({...question, ...data.questions[nextIdx]});
            setIdx(nextIdx)
        }

    }

    const onRetryHandle = () =>{
        setFeedbackState(false,false)
        setClickable(true)
    }

    const onPreviousHandle = () => {

        setFeedbackState(false, false)
        setInteractionState({ view: 'orbit' })
        setQuestion({...question, ...data.questions[0]});
        setIdx(0)
    }

    const onDecisionsClickHandle = (e, decision) => {

        const pos = calcPos(e, {
            "meridian": 500,
            "propX": 20,
            "propY": 40,
            "offsetConst": e.currentTarget.offsetWidth
        });

        if(decisionContentState && decisionContentState.id === decision.id) {
            setDecisionState(false, false)
        }
        else{

            setDecisionState({...decision, pos:{
                x:pos.x,
                y:pos.y
            },
            feedback: decision.text}, true)
        }
    }
    console.log(question)
    return (
        <InteractionContainer withFrame={true} breadcrumbs={props.breadcrumbs}>
            <div className="back-btn-container back-btn">
                <BackButton text={'Back'} onClick={onPreviousHandle} />
            </div>
            <div className="orbit-and-review" ref={viewPortRef}>
                <p className="instruction-text">{data.InstructionsText}</p>
                { interactionState.view === 'orbit' &&
                    <>

                        <div className="options flex-content media">
                        { question && question.media &&
                            <>
                                {question.media.map((media, index)=>(<Media
                                key={index}
                                caption={media?.caption}
                                src={media.src}
                                type={media?.type || 'image'}
                                alt={media?.alt || `Question Media ${index}`} />))}
                                <>
                                {//pagination goes here
                                }
                                </>
                            </>
                        }
                        </div>
                        { question &&
                            <div className="question flex-content" >
                                <div className='inquiry'>
                                    {question.inquiry}
                                </div>
                                <div className='answers'>
                                    {question.answers.map( (answer, index) => {
                                        return(
                                            <div className="option-container">
                                            <div key={index}
                                                className={`option ${answer.selected ? 'selected' : ''} ${!clickable && "nonClickable"}`}
                                                onClick={(e) => onSelectOptionHandle(e, answer,index)}
                                            >
                                                {answer.text}
                                            </div>
                                            {optionClicked[index] !== null&&
                                                <>
                                                    {optionClicked[index]?
                                                        <img alt="Correct Icon" src={CorrectIcon} />
                                                        :
                                                        <img alt={"Wrong Icon"} src={WrongIcon} />
                                                    }
                                                </>
                                            }
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        }
                        <div className={`launch-sites-grid item shrink ${ showFeedback ? 'visible' : 'hidden'}`}>

                            {selectedOption &&
                            <PopContent refObj={choiceFeedbackRef} content={selectedOption} correct={selectedOption.correct} >
                                <div className="buttons-holder">
                                {!selectedOption.correct && <Button className='expand small' text='Retry' onClick={onRetryHandle} />}
                                {selectedOption.correct && <Button className='expand small success' text='Continue' onClick={onNextHandle} />}
                                </div>
                            </PopContent> }
                        </div>
                    </>
                }
                {/* leave for v2 */}
                {/* {interactionState.view === 'decisionsRoadmap' &&
                    <div className="decisionRoadmap-container">

                        <div className={`decisionRoadmap ${ showDecisionContent ? 'visible' : 'hidden'}`}>

                        {decisionContentState &&
                            <PopContent refObj={decisionContentRef} content={decisionContentState} /> }
                        </div>
                        <SVGRoadMap>
                            <g id="prefix__XMLID_27_">
                                {data.decisions.map((decision,index)=>{

                                    return(
                                        <circle
                                            key={index}
                                            onClick={(e)=>onDecisionsClickHandle(e, decision)}
                                            id={decision.id}
                                            className="prefix__st2 actionAble"
                                            cx={decision.cx}
                                            cy={decision.cy}
                                            fill="url(#image)"
                                            r={20.8}
                                        />
                                    )
                                })}
                            </g>
                        </SVGRoadMap>
                        <div className="return-to-questions">
                            <Button className="small" text="Return to Questions" onClick={onPreviousHandle} />
                        </div>
                        <div style={{position:"absolute", bottom: "20px", right: "30px"}}>
                            <Button className="small" text="Next" onClick={props.onComplete} />
                        </div>
                    </div>
                } */}
            </div>
        </InteractionContainer>
    )
}


export default OrbitAndReview
